<template>
  <div>
    <div v-for="language in supportedLanguages" :key="language">
      <div :class="{ 'input-group': multiLanguage, 'error': hasMultilingualError(getName(language)) }">
        <div
          v-if="multiLanguage"
          :id="language + '-ml'"
          class="input-group-addon"
        >
          {{ language }}
        </div>
        <input
          v-if="mode === 'text'"
          type="text"
          :maxlength="maxLength"
          class="form-control"
          :aria-labelledby="language + '-ml'"
          :name="getName(language)"
          :value="getValue(language)"
          @input="e => onInput(language, property, e.target.value)"
        />
        <textarea
          v-if="mode === 'textarea'"
          rows="3"
          class="form-control"
          :aria-labelledby="language + '-ml'"
          :name="getName(language)"
          :value="getValue(language)"
          @input="e => onInput(language, property, e.target.value)"
        ></textarea>
        <markdown-editor
          v-if="mode === 'markdown'"
          :id="`multilingual-${language}-${property}`"
          :mode="markDownMode"
          :spell-checker="language === 'en_GB'"
          :name="getName(language)"
          :value="getValue(language)"
          :markdown-guide-label="lang.get('miscellaneous.markdown_guide.label')"
          @input="value => onInput(language, property, value)"
        />
        <slot :name="`for-${language}`"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import MarkdownEditor from '@/lib/components/Shared/MarkdownEditor';
import {mapGetters, mapState} from "vuex";

export default {
  inject: ['lang'],
  components: {
    MarkdownEditor
  },
  props: {
    mode: {
      type: String,
      default: 'text',
      validator: mode => ['text', 'textarea', 'markdown'].includes(mode)
    },
    supportedLanguages: {
      type: Array,
      required: true
    },
    resource: {
      type: Object,
      required: true,
      validator: resource => resource.hasOwnProperty('translated')
    },
    property: {
      type: String,
      required: true
    },
    maxLength: {
      type: Number,
      default: 524288
    },
    markDownMode: {
      type: String,
      default: 'single-line',
      validator: mode => ['full', 'single-line'].includes(mode)
    }
  },
  computed: {
    ...mapState('global', ['validationErrors']),
    ...mapGetters('global', ['hasMultilingualError']),
    multiLanguage() {
      return this.supportedLanguages.length > 1;
    }
  },
  methods: {
    getName(language) {
      return `translated[${this.property}][${language}]`;
    },
    getValue(language) {
      const translated = this.resource.translated[language] || {};
      return translated[this.property];
    },
    onInput(language, property, value) {
      const translated = JSON.parse(JSON.stringify(this.resource.translated));

      if (!translated[language]) {
        translated[language] = {};
      }

      translated[language][property] = value;
      this.$emit('input', translated, language, property, value);
    }
  }
};
</script>
